const getAsString = (envVar, defaultValue) => {
  let returnedObject = defaultValue;
  if (envVar !== undefined) {
    returnedObject = envVar;
  }
  return returnedObject;
};
const getAsObject = (envVar, defaultValue) => {
  let returnedObject = defaultValue;
  if (envVar !== undefined) {
    try {
      returnedObject = JSON.parse(envVar);
    } catch (e) {
      console.log(`[config::getAsObject] The env var ${envVar} can't be parsed as an object!`);
    }
  }
  return returnedObject;
};
const getAsInt = (envVar, defaultValue) => {
  let returnedInt = defaultValue;
  if (envVar !== undefined) {
    try {
      const parsedValue = parseInt(envVar, 10);
      if (!isNaN(parsedValue)) {
        returnedInt = parsedValue;
      } else {
        console.log(`[config::getAsObject] The env var ${envVar} can't be parsed as an int!`);
      }
    } catch (e) {
      console.log(`[config::getAsObject] The env var ${envVar} can't be parsed as an int!`);
    }
  }
  return returnedInt;
};
const getAsBoolean = (envVar, defaultValue) => {
  let returnedBoolean = defaultValue;
  if (envVar !== undefined) {
    if (['true', 'True', 'TRUE'].includes(envVar)) {
      returnedBoolean = true;
    } else if (['false', 'False', 'FALSE'].includes(envVar)) {
      returnedBoolean = false;
    }
  }
  return returnedBoolean;
};

const config = {
};

config.API_URL = getAsString(process.env.VUE_APP_DAGOBAH_API_URL, 'http://127.0.0.1:3000/api/v2');

config.AUTH_URL = getAsString(process.env.VUE_APP_DAGOBAH_AUTH_URL, 'https://dagobah.security.intraorange:8443/auth');
config.AUTH_REALM = getAsString(process.env.VUE_APP_DAGOBAH_AUTH_REALM, 'DAGOBAH-PROD-REALM');
config.AUTH_CLIENT_ID = getAsString(process.env.VUE_APP_DAGOBAH_AUTH_CLIENT_ID, 'Dagobah-Web-UI-Integration');

config.NOT_USED_1 = getAsBoolean(process.env.VUE_APP_DAGOBAH_ENV_1, true);
config.NOT_USED_2 = getAsObject(process.env.VUE_APP_DAGOBAH_ENV_2, {});
config.NOT_USED_3 = getAsInt(process.env.VUE_APP_DAGOBAH_ENV_3, "126");

module.exports = config;
